import PropTypes from "prop-types";
import React, { act, useEffect, useState } from "react";
import { Input, Media, Modal, ModalBody, Popover, PopoverBody } from "reactstrap";
import floder from "../../../../../assets/images/folder3.png";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import { getmedia } from "live-slices/thunk";
import { createFolder as CreateFolderApi, getfolderByProduct, getmediaByProduct, } from "live-slices/media-center/thunk";
import MediaBreadCrumb from "./MediaBreadCrumb";


const MediaCenterUploadModal = ({ show, onAction, isMultiple, onCloseClick }: any) => {
    const [activeItems, setActiveItems] = useState<{ [key: string]: boolean }>({});
    const isAnyActive = Object.values(activeItems).some((isActive) => isActive);
    const dispatch = useDispatch<any>();
    const [isLoading, setIsLoading] = useState(false);
    const [folderStack, setFolderStack] = useState<{ name: string, id: string }[]>([]);
    const [selectedFolderName, setSelectedFolderName] = useState<string | null>(null);
    const [startDate, setStartDate] = useState<number>(0);
    const [endDate, setEndDate] = useState<number>(0);
    // const [folderId, setFolderId] = useState('');
    const [keyword, setKeyword] = useState('');
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [DetailModal, setDetailModal] = useState<boolean>(false);
    const [selectedImageForDetails, setselectedImageForDetails] = useState(null);
    const [selectedMediaId, setselectedMediaId] = useState(null);
    const [selectedMedia, setSelectedMedia] = useState<Media[]>([]);
    const [moveToFolderModal, setMoveToFolderModal] = useState<boolean>(false);
    const [isModalOpen, setIsModalOpen] = useState(true);

    const handleCheckboxChange = (id: string) => {
        if (isMultiple) {
            setActiveItems((prev: any) => {
                const newActiveItems = { ...prev };
                newActiveItems[id] = !prev[id];

                if (!newActiveItems[id]) {
                    setSelectedMedia(prevMedia =>
                        prevMedia.filter((mediaItem: any) => mediaItem._id !== id)
                    );
                } else {
                    const selectedItem = media.find((item: any) => item._id === id);
                    if (selectedItem) {
                        setSelectedMedia(prevMedia => [...prevMedia, selectedItem]);
                    }
                }

                return newActiveItems;
            });
        } else {
            setActiveItems((prev: any) => {
                const newActiveItems = { [id]: !prev[id] };

                if (!newActiveItems[id]) {
                    setSelectedMedia(prevMedia =>
                        prevMedia.filter((mediaItem: any) => mediaItem._id !== id)
                    );
                } else {
                    const selectedItem = media.find((item: any) => item._id === id);
                    if (selectedItem) {
                        setSelectedMedia(prevMedia => [...prevMedia, selectedItem]);
                    }
                }

                return newActiveItems;
            });
        }
    };


    const onCancalClick = () => {
        setActiveItems({});
        setSelectedMedia([]);
    };



    const handleSelectMedia = (media: Media) => {
        setSelectedMedia((prev) => [...prev, media]);
    };

    const mediaDataByProduct = createSelector(
        (state: any) => state.MediaCenter,
        (mediaByProduct) => mediaByProduct?.mediaByProduct
    );

    const media = useSelector(mediaDataByProduct);

    const folderData = createSelector(
        (state: any) => state.MediaCenter,
        (folderByProduct) => folderByProduct?.folderByProduct
    );
    const folder = useSelector(folderData);


    const handleFolderClick = async (folderName: string, folderId: string) => {
        setIsLoading(true);
        try {
            setActiveItems({});
            setFolderStack((prevStack) => [...prevStack, { name: folderName, id: folderId }]);
            setSelectedFolderName(folderName);
            // setFolderId(folderId);
            await dispatch(getmediaByProduct({ folderid: folderId, keyword, stardate: startDate, enddate: endDate }));
            await dispatch(getfolderByProduct(folderId));
        } catch (error) {
            console.error("Error fetching folder data", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleBackClick = async (index: number, id: string = "", name: string = "Image") => {
        if (isLoading) return;
        setIsLoading(true);
        try {
            const selectedFolder = folderStack[index];
            if (id === "") {
                selectedFolder.id = "";
                selectedFolder.name = name;
            }
            await dispatch(getfolderByProduct(selectedFolder.id));
            await dispatch(getmediaByProduct({ folderid: selectedFolder.id, keyword, stardate: startDate, enddate: endDate }));
            setFolderStack((prevStack) => prevStack.slice(0, index + 1));

        } catch (error) {
            console.error("Error fetching folder data", error);
        } finally {
            setIsLoading(false);
        }
    };

    // useEffect(() => {
    //     if (folderId) {
    //         dispatch(getmediaByProduct({ folderid: folderId, keyword, stardate: startDate, enddate: endDate }));
    //     } else {
    //         dispatch(getfolderByProduct(""))
    //         dispatch(getmediaByProduct({ folderid: "", keyword, stardate: startDate, enddate: endDate }));
    //     }
    // }, [folderId]);

           useEffect(() => {
                dispatch(getmediaByProduct({ folderid:folderStack.length>0? folderStack[folderStack.length-1].id:"", keyword, stardate: startDate, enddate: endDate }));
                dispatch(getfolderByProduct(folderStack.length>0? folderStack[folderStack.length-1].id:"",))
                // if (folderStack.length>0) {
                // } else {
                //     dispatch(getFolderApi(""))
                //     dispatch(getMediaApi({ folderid: "", keyword, stardate: startDate, enddate: endDate }));
                // }
            }, []);

    useEffect(() => {
    }, [media]);

    const handleClear = () => {
        setStartDate(0);
        setEndDate(0);
        setKeyword('');
        dispatch(getmediaByProduct({folderid: folderStack.length>0? folderStack[folderStack.length-1].id:"", keyword, stardate: startDate, enddate: endDate }));
    };

    // const handleSubmit = () => {
    //     submitButton(selectedMedia);
    // };

    const handleConfirm = () => {
        const selectedItems = media
            .filter((item: any) => activeItems[item._id])
            .map((item: any) => ({
                url: item.url || 'https://via.placeholder.com/120',
                metaData: item.metaData || {},
            }));


        if (selectedItems.length > 0) {
            onAction(selectedItems);
            setIsModalOpen(false);
        } else {
            alert('No items selected.');
        }
    };


    return (
        <Modal isOpen={show} toggle={onCloseClick} centered={true} className="imageUpladmodal position-relative">
            <ModalBody className="py-3 px-5">
                <div className="d-flex justify-content-between align-items-center">
                    <h4>Media Center </h4>
                    <i
                        className="bx bx-x fs-2 cursor-pointer"
                        data-testing-id="closeIcon_mediaCenter"
                        style={{ color: "#CACACA" }}
                        onClick={onCloseClick}
                    ></i>
                </div>
                <div className="d-flex justify-content-end align-items-center gap-2 my-3">
                    <div className="dateInput">
                        <Input
                            className=""
                            type="date"
                            placeholder="Start Date"
                            data-testing-id="startDate_mediaCenter"
                        />
                    </div>
                    <div className="dateInput">
                        <Input
                            className=""
                            type="date"
                            placeholder="End Date"
                            data-testing-id="endDate_mediaCenter"
                        />
                    </div>
                    <Input
                        type="text"
                        placeholder="Search picture name"
                        data-testing-id="searchImage_mediaCenter"
                    />
                </div>

                {folderStack.length > 0 && (
                    <MediaBreadCrumb folderStack={folderStack} handleBackClick={handleBackClick} isLoading={isLoading} />
                )}

                <div className="folderDv">

                    <div className="d-flex justify-content-between align-items-center ">
                        <h4>Folder</h4>

                    </div>
                    <div className="ImageRow d-flex justify-content-start align-items-center flex-wrap gap-3 mb-3">
                        {isLoading ? (
                            <div className="loader">Loading...</div>
                        ) : folder && folder.length > 0 ? (
                            folder.map((item: any) => (
                                <div
                                    key={item._id}
                                    className="imageBoxActive avatar-sm rounded-2 d-flex justify-content-start align-items-center flex-column gap-2 py-2"
                                    style={{
                                        cursor: 'pointer',
                                        width: '140px',
                                        height: '200px',
                                        background: 'rgb(243 243 243)',
                                    }}
                                    onClick={() => handleFolderClick(item.folderName, item._id)}
                                >
                                    <div className="d-flex justify-content-end fs-3 w-100 z-3">

                                    </div>

                                    <div style={{ width: '120px', height: '130px' }} className="mb-3"
                                    >
                                        <img
                                            src={floder} // Ensure 'floder' is correctly imported
                                            alt="Folder Image"
                                            className="img-fluid d-block w-100 h-100"
                                        />
                                    </div>
                                    <p
                                        className="m-0 text-center fs-6"
                                        style={{
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            width: '110px',
                                        }}
                                    >
                                        {item.folderName || 'Folder Name'}
                                    </p>
                                </div>
                            ))
                        ) : (
                            <p>No folders available</p>
                        )}
                    </div>

                    <div>
                        <h5>Select Files</h5>
                        <div className="ImageRow d-flex justify-content-start align-items-center flex-wrap gap-3 mb-3">
                            {media && media.length > 0 ? (
                                media.map((item: any) => (
                                    <div
                                        key={item._id}
                                        className={`imageBoxActive avatar-sm rounded-2 d-flex justify-content-start align-items-center flex-column gap-2 py-2 ${activeItems[item?._id] ? 'checked-box' : ''}`}
                                        style={{
                                            cursor: 'pointer',
                                            width: '140px',
                                            height: '160px',
                                            backgroundColor: activeItems[item?._id] ? '#CACACA' : 'rgb(243 243 243)',
                                            border: activeItems[item?._id] ? '2px solid #0877FF' : 'none',
                                        }}
                                    >
                                        <div className="d-flex justify-content-between align-items-center w-100 px-1">
                                            <input
                                                type="checkbox"
                                                className="productCheckBox form-check-input"
                                                data-testing-id="imageCheckbox_mediaCenter"
                                                onChange={() => handleCheckboxChange(item._id)}
                                                checked={!!activeItems[item._id]}
                                            />

                                        </div>

                                        <div style={{ width: '120px', height: '130px' }} className="mb-3 BoxActiveImage" >
                                            <img
                                                src={item.url || 'https://via.placeholder.com/120'}
                                                alt="media"
                                                className="img-fluid d-block w-100"
                                                style={{ height: "100px" }}
                                            />
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>No media available</p>
                            )}
                        </div>
                    </div>



                </div>
            </ModalBody>

            <div className="position-sticky bottom-0">
                {isAnyActive && (
                    <div className="p-3" style={{ background: "#D4E8FF" }}>
                        <div className="selectedImagesContainer d-flex gap-2 mt-2" style={{width: "100%", overflowX: "auto" }}>
                            {Object.entries(activeItems)
                                .filter(([id, isActive]) => isActive)
                                .map(([id]) => {
                                    // Find the selected item in the media array
                                    const selectedItem = media.find((item: any) => item._id === id);
                                    if (!selectedItem) return null;

                                    // Destructure url and name
                                    const { url: mediaUrl = "", metaData: { name: mediaName = "Untitled" } = {} } = selectedItem;

                                    return (
                                        <div
                                            key={id}
                                            className="selectedImageBox avatar-sm rounded-2 d-flex flex-column align-items-center position-relative"
                                            style={{
                                                width: "100px",
                                                height: "130px",
                                                background: "#F3F3F3",
                                            }}
                                        >
                                            <button
                                                type="button"
                                                className="btn-close position-absolute top-0 end-0 m-1"
                                                onClick={() => {
                                                    setActiveItems((prev) => {
                                                        const updatedItems = { ...prev };
                                                        delete updatedItems[id];
                                                        return updatedItems;
                                                    });
                                                    setSelectedMedia((prev) =>
                                                        prev.filter((mediaItem: any) => mediaItem._id !== id)
                                                    );
                                                }}
                                                style={{
                                                    backgroundColor: "#fff",
                                                    borderRadius: "50%",
                                                    border: "none",
                                                    width: "20px",
                                                    height: "20px",
                                                    padding: "0",
                                                }}
                                                aria-label="Remove"
                                            ></button>

                                            <img
                                                src={mediaUrl}
                                                alt={mediaName}
                                                className="img-fluid w-100 h-auto mb-2"
                                                style={{ maxHeight: "80px" }}
                                            />
                                            <p
                                                className="m-0 text-center fs-6"
                                                title={mediaName}
                                                style={{
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    width: "90px",
                                                }}
                                            >
                                                {mediaName}
                                            </p>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                )}
                <div
                    className="d-flex justify-content-between align-items-center position-sticky w-100 bottom-0 bg-white p-3"
                    style={{ boxShadow: "0px 0px 11px -4px #CACACA" }}
                >
                    <p className="text-secondary p-0 m-0"
                        onClick={() => window.open('/media-center', '_blank')}
                        style={{ cursor: 'pointer' }}
                        >
                        Go to Media Center
                        </p>

                    <div className="text-end ">
                        <button
                        style={{width: "fit-contain", borderRadius: "5px", padding: "10px 12px", marginRight: "10px" }}
                            type="button"
                            
                            className=""
                            data-testing-id="confirmButton_mediaCenter"
                            onClick={() => {
                                handleConfirm();
                                onCloseClick();
                                onCancalClick();
                            }}
                        >
                            Confirm
                        </button>
                        <button
                            className="btn btn-outline-dark lightGrayButton"
                            type="submit"
                            onClick={() => {
                                onCancalClick();
                                onCloseClick();
                            }}
                            data-testing-id="cancelButtonUpload_mediaCenter"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>


        </Modal>
    );
};

MediaCenterUploadModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    onAction: PropTypes.func.isRequired,
    isMultiple: PropTypes.bool,

};

export default MediaCenterUploadModal;
